// lib/parseStock
/**
 * Переназываем склады
 */

export default {
  filters: {
    parseStock: function(stock) {
      return (stock==='ПИК') ? 'ПИК' : 'ВМКТ';
    }
  }
}


/** WEBPACK FOOTER **
 ** ./src/js/lib/filters/parseStock.js
 **/